module.exports = __webpack_public_path__ + "img/logo.e1b2cc05.png";